import { render, staticRenderFns } from "./DeleteAddressesModal.vue?vue&type=template&id=0f9f4903&scoped=true&"
import script from "./DeleteAddressesModal.vue?vue&type=script&lang=js&"
export * from "./DeleteAddressesModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAddressesModal.vue?vue&type=style&index=0&id=0f9f4903&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9f4903",
  null
  
)

export default component.exports